import { render, staticRenderFns } from "./CmgOrderConfirmationHeader.vue?vue&type=template&id=5a1cd7cf&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationHeader.vue?vue&type=style&index=0&id=5a1cd7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1cd7cf",
  null
  
)

export default component.exports